import { ITracker } from '@didi/omega-tracker-lite/src/interface/tracker';
import getSign, { initSign } from '@didi/wsgsig';

const MARKET_BIZ_ID = 'e31c33d15c8dd722b6bc09639d6f0973'; // 专门为营销前端生成的bizId

interface SCGParams {
    env?: 'ame'; // ame：美东环境；默认不填，为国内环境；这里必须美东环境
    bizId: string; // 专门为营销前端生成的bizId
    appVer: string; // 当前程序的版本号，跟程序的版本号同步，方便问题排查时定位版本tag
    os?: '4'; // H5、PC
    omega?: ITracker; // omega实例
}

const initSCG = (params: SCGParams) => {
    initSign({
        env: 'ame',
        os: '4',
        omega: window.Omega,
        ...params
    });
};

export { getSign, initSCG, MARKET_BIZ_ID };
